import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AuthModule } from 'shared/auth/auth.module';
import { GetStartedRoutingModule } from './get-started-routing.module';
import { GetStartedComponent } from './get-started.component';
import { SharedModule } from 'shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    GetStartedRoutingModule,
  ],
  declarations: [GetStartedComponent],
  exports: [GetStartedComponent]
})
export class GetStartedModule {}
